import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ConfigProvider } from "antd";
import faIR from "antd/lib/locale/fa_IR";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider
      direction="rtl"
      locale={faIR}
      theme={{ token: { fontFamily: "iranSans" } }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
